import { createContext } from 'react';
import { captureException } from '@sentry/react';
import { useQueryClient } from '@tanstack/react-query';
import { useFlag } from '@fusion/feature-flags';

import {
  useUserGroupsQuery,
  type UseUserGroupsQueryResult,
} from '../../features/access/hooks/use-user-groups-query';
import { useCurrentUserContext } from '../current-user-provider/current-user-provider';
import { useCdmSelectedLocationContext } from '../selected-location-provider/cdm-selected-location-context';
import type { offlineStores } from './use-offline-store/consts';
import { useOfflineStore } from './use-offline-store/use-offline-store';

export interface UseSaveCdmOfflineConfigurationContextInterface {
  useQueryClient: typeof useQueryClient;
  captureException: typeof captureException;
  useOfflineStore: (
    name: typeof offlineStores.Configuration
  ) => Pick<ReturnType<typeof useOfflineStore>, 'offlineStore' | 'scope'>;
  useCurrentUserContext: typeof useCurrentUserContext;
  useUserGroupsQuery: () => Pick<
    UseUserGroupsQueryResult,
    'data' | 'isSuccess'
  >;
  useCdmSelectedLocationContext: () => Pick<
    ReturnType<typeof useCdmSelectedLocationContext>,
    'selectedLocationConfig'
  >;
  useFlag: typeof useFlag;
}

export const UseSaveCdmOfflineConfigurationContext =
  createContext<UseSaveCdmOfflineConfigurationContextInterface>({
    useQueryClient,
    captureException,
    useOfflineStore,
    useCurrentUserContext,
    useUserGroupsQuery,
    useCdmSelectedLocationContext,
    useFlag,
  });
